import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
import Header from './components/Header';
import Footer from './components/Footer';
import FloatingWhatsApp from './components/FloatingWhatsApp';
import MobileStickyBar from './components/MobileStickyBar';
import HomePage from './pages/HomePage';
import WohnungsraeumungPage from './pages/WohnungsraeumungPage';
import HaushaltsaufloesungPage from './pages/HaushaltsaufloesungPage';
import NachlassraeumungPage from './pages/NachlassraeumungPage';
import MessieWohnungPage from './pages/MessieWohnungPage';
import KellerraeumungPage from './pages/KellerraeumungPage';
import BueroRaeumungPage from './pages/BueroRaeumungPage';
import DachbodenRaeumungPage from './pages/DachbodenRaeumungPage';
import NiederoesterreichPage from './pages/NiederoesterreichPage';

export default function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <div className="font-sans text-[#2D2D2D] bg-white">
          <Header />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/wohnungsraeumung-wien" element={<WohnungsraeumungPage />} />
            <Route path="/haushaltsaufloesung-wien" element={<HaushaltsaufloesungPage />} />
            <Route path="/nachlassraeumung-wien" element={<NachlassraeumungPage />} />
            <Route path="/messie-wohnung-wien" element={<MessieWohnungPage />} />
            <Route path="/kellerraeumung-wien" element={<KellerraeumungPage />} />
            <Route path="/bueroraeumung-wien" element={<BueroRaeumungPage />} />
            <Route path="/dachbodenraeumung-wien" element={<DachbodenRaeumungPage />} />
            <Route path="/raeumung-niederoesterreich" element={<NiederoesterreichPage />} />
          </Routes>
          <Footer />
          <FloatingWhatsApp />
          <MobileStickyBar />
        </div>
      </Router>
    </HelmetProvider>
  );
}
